import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './SubmitButton.module.css';
export const SubmitButton = forwardRef(({ text, loading = false, disabled = false, onClick, type = 'submit', variant = 'primary', className = '', ...props }, ref) => {
    const classes = [
        styles.button,
        styles[variant],
        loading && styles.loading,
        disabled && styles.disabled,
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("button", { ref: ref, type: type, className: classes, disabled: disabled || loading, onClick: onClick, "aria-busy": loading, ...props, children: [loading && (_jsx("span", { className: styles.spinner, "aria-hidden": "true", children: _jsxs("svg", { className: styles.spinnerIcon, viewBox: "0 0 24 24", fill: "none", children: [_jsx("circle", { className: styles.spinnerTrack, cx: "12", cy: "12", r: "10", strokeWidth: "3" }), _jsx("path", { className: styles.spinnerPath, d: "M12 2a10 10 0 0 1 10 10", strokeWidth: "3", strokeLinecap: "round" })] }) })), _jsx("span", { className: styles.text, children: loading ? 'Loading...' : text })] }));
});
SubmitButton.displayName = 'SubmitButton';
